import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

/**
 * `expireAsset` request params
 * (what is used to send to server)
 */
export interface ExpireAssetRequestOptions {
	id: number;
	expirationDate: number;
}

type RequiredExpireAssetRequestOptions = Required<ExpireAssetRequestOptions>;

/**
 * `expireAsset` request
 * (what gets sent to the server)
 */
export type ExpireAssetRequest = [
	RequiredExpireAssetRequestOptions['id'],
	RequiredExpireAssetRequestOptions['expirationDate'],
];

/**
 * `expireAsset` response
 * (what comes back from the server)
 */
export type ExpireAssetResponse = SuccessResponse<ExpireAssetResult>;

/**
 * `expireAsset` result
 * (what is utilized from the server response)
 */
export type ExpireAssetResult = boolean;

export const expireAssetEndpoint = 'expireAsset';

/**
 * Expire/unexpire asset
 * @param expirtationParams
 */
export const expireAsset = async ({
	id,
	expirationDate,
}: ExpireAssetRequestOptions): Promise<ExpireAssetResult> => {
	const client = NetxQueryClient();

	const requestParams: ExpireAssetRequest = [id, expirationDate];

	const response = await client.post<ExpireAssetResponse>(
		expireAssetEndpoint,
		requestParams,
	);

	if (response.data.result === false)
		throw new Error('Unable to set asset expiration');
	return true;
};

export default expireAsset;
